<template>
  <div>
    <v-form ref="form" v-model="valid">
      <teacher-lookup v-model="selectedTeacher" :required="true" />
      <v-select
        v-model="selectedCenter"
        :items="myCenters"
        label="Location"
        item-text="name"
        item-value="id"
      />
      <date-picker
        label="Start Date"
        :defaultNowOnNull="false"
        :show-hint="false"
        :show-icon="false"
        v-model="selectedDate"
        :outlined="false"
        clearable
      />
      <v-text-field
        v-model="internalStartTime"
        label="Start Time*"
        type="time"
        :rules="[rules.required]"
        required
      />
      <v-text-field
        v-model="internalEndTime"
        label="End Time*"
        type="time"
        :rules="[rules.required]"
        required
      />
      <v-textarea
        v-model="remark"
        label="Notes"
        auto-grow
        :rows="1"
        clearable
      />
      <v-checkbox v-model="isRecurring" label="Recurring Schedule?" />
      <div v-if="isRecurring">
        <date-picker
          label="End Date"
          :defaultNowOnNull="false"
          :show-hint="false"
          :show-icon="false"
          v-model="endDate"
          clearable
        />
        <div class="d-flex justify-space-around">
          <v-checkbox
            v-for="(day, index) in daysOfWeek"
            :key="index"
            v-model="day.selected"
            :label="day.label"
          />
        </div>
      </div>
      <v-card-actions>
        <v-btn
          class="mx-auto"
          color="green darken-1"
          text
          :loading="isLoading"
          @click="createAvailability"
        >
          Create Availability
        </v-btn>

        <v-btn color="blue darken-1" text @click="onClose"> Close </v-btn>
      </v-card-actions>
    </v-form>

  </div>
</template>

<script>
import dialogMixin from './dialogMixin.js'
import { mapActions, mapGetters } from "vuex";
const TeacherLookup = () => import("@/components/teacher/TeacherLookup.vue");
import { EventBus } from "@/EventBus.js";

export default {
    mixins: [dialogMixin],
  props: {
    selectedTeacher: {
      type: Object,
      required: true,
    },
    selectedDate: {
      type: Date,
      required: true,
    },
    startTime: {
      type: String,
      default: null,
    },
    endTime: {
      type: String,
      default: null,
    },
  },
  components: { TeacherLookup },
  computed: {
    ...mapGetters(["globalCenter", "myCenters"]),
  },
  watch: {
    selectedTeacher(newVal) {
      this.selectedTeacher = newVal;
    },
    selectedDate(newVal) {
      this.selectedDate = newVal;
    },
    startTime(newVal) {
      this.internalStartTime = newVal;
    },
    endTime(newVal) {
      this.internalEndTime = newVal;
    },
  },
  data: () => ({
    isLoading: false,
    selectedTeacher: null,
    selectedCenter: null,
    isRecurring: false,
    endDate: null,
    internalStartTime: null,
    internalEndTime: null,
    remark: "",
    rules: {
      required: (value) => !!value || "Required.",
      endDate: (value) => {
        if (this.selectedDate && value) {
          return (
            new Date(value) >= new Date(this.selectedDate) ||
            "End date cannot be earlier than start date."
          );
        }
        return true;
      },
    },
    daysOfWeek: [
      { label: "Sun", selected: false },
      { label: "Mon", selected: false },
      { label: "Tue", selected: false },
      { label: "Wed", selected: false },
      { label: "Thu", selected: false },
      { label: "Fri", selected: false },
      { label: "Sat", selected: false },
    ],
  }),
  mounted() {
    this.selectedCenter = this.globalCenter.id;
    this.internalStartTime = this.startTime;
    this.internalEndTime = this.endTime;
  },
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage", "clearMessage"]),
    createAvailability() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.isLoading = true;
      const timezoneOffset = new Date().getTimezoneOffset();

      const data = {
        startDate: this.selectedDate,
        endDate: this.endDate,
        daysOfWeek: this.daysOfWeek
          .filter((dow) => dow.selected)
          .map((dow) => dow.label),
        remark: this.remark,
        onlineOnly: this.onlineOnly,
        startTime: this.internalStartTime,
        endTime: this.internalEndTime,
        teacherId: this.selectedTeacher.id,
        timezoneOffset: timezoneOffset,
      };
      this.$axios
        .post("/teachers/availability/update", data)
        .then((resp) => {
          this.isLoading = false;
          const savedAvailability = resp.data.data;
          this.addSuccessMessage("Teacher availability updated");

          // const event = {
          //   type: "added-teacher-availability",
          //   data: savedAvailability,
          //   teacherId: this.selectedTeacher ? this.selectedTeacher.id : null,
          // };
          // this.$emit("on-success", event);
          EventBus.$emit('reload-chart', {savedAvailability})
        })
        .catch((error) => {
          this.isLoading = false;
          this.$emit("on-error", error);
          this.addErrorMessage(error.message);
        });
    },
  },
};
</script>
